import { createActionGroup, props } from '@ngrx/store';
import { Budget, UploadResponse } from '@tdf/rtpca-models';

export const budgetApiActions = createActionGroup({
  source: 'Budget API',
  events: {
    'Load Budget': props<{ refinery: string }>(),
    'Load Budget Success': props<{ budgets: Budget[] }>(),
    'Load Budget Failure': props<{ error: string }>(),
    'Save Budget': props<{ budget: Budget; file?: any }>(),
    'Save Budget Success': props<{ budget: Budget; isBudget: UploadResponse, file?: File }>(),
    'Save Budget Failure': props<{ error: unknown, refinery: string }>(),
    'Update Budget': props<{ budget: Budget; isBudget: UploadResponse, file: File, refinery: string}>(),
    'Update Budget Success': props<{ budget: Budget, refinery: string}>(),
    'Update Budget Failure': props<{ error: unknown, refinery: string }>(),
    'Delete Budget': props<{ budgetId: number, refinery: string }>(),
    'Delete Budget Success': props<{ budgetId: number, refinery: string }>(),
    'Delete Budget Failure': props<{ error: string }>(),
    'Set Update': props<{ isUpdate: boolean; id: number }>(),
    'Update Budget Name': props<{ budgetId: number; newName: string; refinery: string }>(),
    'Update Budget Name Success': props<{ budgetId: number, refinery: string}>(),
    'Update Budget Name Failure': props<{ error: string, refinery: string}>(),
  },
});
